export * from './enums'

export const RUN_ON_PAGE_UPLOAD_MESSAGE_STANDARD = 'Process a page uploaded to a gallery'
export const RUN_ON_PAGE_UPLOAD_MESSAGE_SHORT = 'Run on page upload'
export const RUN_ON_PAGE_UPLOAD_MESSAGE_HELP = "The model will process each image uploaded to the session's gallery."

export const RUN_ON_FORM_ANSWER_MESSAGE_STANDARD = 'Process a page which has an answer on a form'
export const RUN_ON_FORM_ANSWER_MESSAGE_SHORT = 'Run on form answer'
export const RUN_ON_FORM_ANSWER_MESSAGE_HELP =
  'The model will process each image that received an answer if the corresponding question has an attached VQA policy.'
